module.exports = __webpack_public_path__ + "img/Hellio_80X30.74fae7a6.png";